import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Regexes carried over from the Angular 7 app as they were.
// eslint-disable-next-line no-control-regex
const EMAIL_REGEX = /^(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){255,})(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){65,}@)(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22))(?:\.(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22)))*@(?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-z0-9]+(?:-+[a-z0-9]+)*\.){1,126})+(?:(?:[a-z][a-z0-9]*)|(?:(?:xn--)[a-z0-9]+))(?:-+[a-z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))]))$/;
const PHONE_REGEX = /^(\(?\+?[0-9]*\)?)?[0-9_\- ()]*$/;
const WEBSITE_REGEX =
  /(https?:\/\/[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/[a-zA-Z0-9]+\.[^\s]{2,}|[a-zA-Z0-9]+\.[^\s]{2,})/;
export const DOMAIN_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export const emailValidator: ValidatorFn = ({ value }) => {
  const input = String(value ?? '').toLowerCase();
  const valid =
    input.length <= 320 &&
    EMAIL_REGEX.test(input) &&
    !input.endsWith('\n') &&
    encodeURIComponent(input).replace(/%../g, 'x').length <= 320;
  return valid ? null : { email: 'emailInvalid' };
};

export interface PasswordErrors extends ValidationErrors {
  numbers?: boolean;
  mixedCase?: boolean;
  specialChars?: boolean;
  length?: boolean;
}

export const passwordValidator = ({ value }: AbstractControl): PasswordErrors | null => {
  if (!value || typeof value !== 'string') {
    return null;
  }
  const errors: PasswordErrors = {};
  if (!/(?=.*[A-Z])(?=.*[a-z])/.test(value)) {
    errors.mixedCase = true;
  }
  if (!/[!"#$%&'*+,./:;<=>?@[\]^_`{|}~-]/.test(value)) {
    errors.specialChars = true;
  }
  if (!/\d/.test(value)) {
    errors.numbers = true;
  }
  if (value.length <= 12) {
    errors.length = true;
  }
  return Object.keys(errors).length ? errors : null;
};

export const phoneValidator: ValidatorFn = ({ value }) => {
  const phone = String(value ?? '');
  return phone.trim() && PHONE_REGEX.test(phone) ? null : { phoneInvalid: true };
};

export const websiteValidator: ValidatorFn = ({ value }) =>
  WEBSITE_REGEX.test(String(value ?? '')) ? null : { incorrectUrl: true };
